import React, { Component } from "react";
import mail from "./mail.png";

class FinishMessage extends Component {
  render() {
    window.gtag("event", "conversion", {
      send_to: "AW-961032347/kCuaCLy41uYBEJvhoMoD",
    });

    return (
      <div>
        {!this.props.success && (
          <div>
            <h1
              style={{ textAlign: "center", width: "350px", margin: "0 auto" }}
            >
              Start your free trial today
            </h1>
            <p>
              Take control of your calendar, build your deals, send your
              invoices and connect your team all from a single software
              platform!
              <br />
              <br />
              Free for 14 days and no credit card needed for the trial.
            </p>
          </div>
        )}
        {this.props.success && !this.props.error && (
          <div className="form-success-container">
            <h2>Your trial has been created!</h2> <br />
            <p>
              You will receive an email with further instructions on how to
              proceed at <span>{this.props.email}</span>.
            </p>
            <div className="form-success-container-block">
              <img src={mail} alt="Finish" />
              <p className="small">
                If you do not receive the confirmation message within a few
                minutes of requesting a trial, please check your spam folder.
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default FinishMessage;



// WEBPACK FOOTER //
// src/views/trial/finish-message.js